import { selectComponents, selectAppSettings } from '../store'

if (selectComponents === undefined) throw new Error('selectComponents is undefined')
if (selectAppSettings === undefined) throw new Error('selectAppSettings is undefined')

export const selectFooter = (store) => selectComponents(store).footer
export const selectRelease = (store) => selectAppSettings(store).release
export const selectSignalR = (store) => store.signalR

